// https://sponda-kohteet.stage.crasman.fi/admin/manage/scriptlets/scriptletmanager/scriptleteditor/html/code/show/1H5OP5iMRk2NLYb7bQRWUg

import React from 'react';
import PropTypes from 'prop-types';

import PictogramIcon from 'components/Pictogram';
import { colorClassNames } from 'lib/settings';

const Pictogram = props => {
	const {
		language,
		options,
		componentData: {
			title: savedTitle,
		},
		unsavedChanges,
		itemActiveIndex,
	} = props;

	const backgroundColor = options['background-color'];
	const bgColorClass = backgroundColor in colorClassNames ? colorClassNames[backgroundColor] : '';

	let componentClass = 'b-component b-pictogram';

	if (bgColorClass) {
		componentClass += ' b-slot-theme-' + bgColorClass;
	}

	const style = {
		backgroundColor,
	};

	const title = 'title' in unsavedChanges
		&& language in unsavedChanges.title
		? unsavedChanges.title[language]
		: savedTitle[language];

	const pictograms = props.componentData.pictograms.map((pictogram, pictogramIndex) => {
		const { field } = pictogram;
		const { image: svg } = props.pictograms.find(picto => picto.field === field);
		const label = pictogramIndex === itemActiveIndex
			&& 'i18n' in unsavedChanges
			&& language in unsavedChanges.i18n
			?	unsavedChanges.i18n[language]
			: pictogram.i18n[language];

		return (
			<div className="pictogram" key={field}>
				<PictogramIcon svg={svg} />
				<p>{label}</p>
			</div>
		)
	})

	return (
		<div className={componentClass} style={style}>
			<div className="b-pictogram-content">
				<h1 className="b-pictogram-title">{title}</h1>
				<div className="b-pictogram-pictograms">
					{pictograms}
					{
						!!(props.componentData.pictograms.length % 2) &&
						<div className="pictogram"></div>
					}
				</div>
			</div>
		</div>
	)
}

Pictogram.propTypes = {
	language: PropTypes.oneOf(['fi', 'en']),
	options: PropTypes.object,
	componentData: PropTypes.shape({
		title: PropTypes.shape({
			fi: PropTypes.string,
			en: PropTypes.string,
		}),
		pictograms: PropTypes.array,
	}),
	pictograms: PropTypes.array,
	buildingFieldLocalNames: PropTypes.object,
	unsavedChanges: PropTypes.object,
	itemActiveIndex: PropTypes.number,
}

export default Pictogram;
